import { render, staticRenderFns } from "./Lecture_share.vue?vue&type=template&id=f67ff986&scoped=true"
import script from "./Lecture_share.vue?vue&type=script&lang=js"
export * from "./Lecture_share.vue?vue&type=script&lang=js"
import style0 from "./Lecture_share.vue?vue&type=style&index=0&id=f67ff986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67ff986",
  null
  
)

export default component.exports